import styled from 'styled-components';

export const StyledTooltip = styled.div(
  ({
    maxWidth,
    variant,
    direction,
    position: { left, top },
    theme: {
      colors,
      border,
      font,
      spacing,
      responsive: { mobile },
    },
  }) => {
    const topArrow = {
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderTop: `10px solid ${colors.secondary}`,
      bottom: -10,
      content: '""',
      display: variant === 'arrow' ? 'block' : 'none',
      height: 0,
      left: '50%',
      marginLeft: -10,
      position: 'absolute',
      width: 0,
    };

    const bottomArrow = {
      borderBottom: `10px solid ${colors.secondary}`,
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      content: '""',
      display: variant === 'arrow' ? 'block' : 'none',
      height: 0,
      left: '50%',
      marginLeft: -10,
      position: 'absolute',
      top: -10,
      width: 0,
    };

    return {
      '&:before': {
        ...(direction === 'top' ? topArrow : {}),
        ...(direction === 'bottom' ? bottomArrow : {}),
      },

      alignItems: 'center',
      background: colors.secondary,
      borderRadius: border.radius.md,
      color: colors.white,
      display: 'flex',
      flexDirection: 'column',
      fontSize: font.size.sm,
      fontWeight: variant === 'arrow' ? font.weight.normal : font.weight.bold,
      height: 'auto',
      justifyContent: 'center',
      left,
      lineHeight: variant === 'arrow' ? font.lineHeight.md : font.lineHeight.sm,
      maxWidth: maxWidth || 'none',
      [mobile]: {
        display: 'none',
      },
      padding: variant === 'arrow' ? spacing.sm : `${spacing.xs} ${spacing.sm}`,
      position: 'absolute',
      top,
      visibility: left && top ? 'visible' : 'hidden',
      zIndex: 9999,
    };
  },
);
